export default __webpack_public_path__ + "static/media/dubbed-srt.6ae30a15.svg";